var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('NavbarContainer',{attrs:{"onToggleMenu":_vm.onToggleMenu,"stateSidebar":_vm.state}}),_c('SidebarAppContainer',{attrs:{"onToggleMenu":_vm.onToggleMenu,"stateSidebar":_vm.state}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }